import Chollo from "../../../../entity/chollo";

var FailedAttemptReporter = function (form)
{
    "use strict";
    var self = this;
    this.form = $(form);
    this.url = myApp.config.routing.reportBookingFailedAttempt;
    this.booking = myApp.bookingService.booking;
    this.chollo = new Chollo();
    this.violationFound = null;
    this.attempttoken = self.form.find('input[name=attempttoken]').first().val();

    this.fetchBookingInfo = function () {
        self.booking.name = self.form.find('input[name=titular_nombre]').first().val();
        self.booking.surname1 = self.form.find('input[name=titular_1]').first().val();
        self.booking.surname2 = self.form.find('input[name=titular_2]').first().val();
        self.booking.dni = self.form.find('input[name=dni]').first().val();
        self.booking.phone = self.form.find('input[name=telefon1]').first().val();
        self.booking.phone2 = self.form.find('input[name=telefon2]').first().val();
        self.booking.email = self.form.find('input[name=mail]').first().val();
        self.booking.email2 = self.form.find('input[name=mail2]').first().val();
        self.booking.children = self.form.find('input[name=nnens]').first().val();
        self.booking.adults = self.form.find('input[name=nadults]').first().val();
        self.chollo.id = self.form.find('input[name=id_chollo]').first().val();
        self.chollo.price = self.form.find('input[name=totalprice]').first().val();
    };

    this.attemptNeedsToBeRegistered = function () {
        var formError = self.form.find("[data-fv-result='INVALID']:visible");
        var isNeeded = false;
        if (formError){
            $(formError).each(function() {
                var error = $( this ).attr('data-fv-for');
                if((error === 'dni' || error === 'mail' || error === 'mail2') && self.booking.name && (self.booking.phone || self.booking.phone2)){
                    self.violationFound = error;
                    isNeeded = true;
                }
            });

        }

        return isNeeded;
    };

    this.report = function () {
        self.fetchBookingInfo();
        if (!self.attemptNeedsToBeRegistered()) {
            return;
        }
        $.post(self.url, {
            'booking': JSON.stringify(self.booking),
            'chollo': JSON.stringify(self.chollo),
            'violation': self.violationFound,
            'token': self.attempttoken
        });
    };
};

export default FailedAttemptReporter;